import styled from 'styled-components';

const H1 = styled.h1`
  margin-bottom: ${props => props.theme.paddingXS};
  font-size: ${props => props.theme.fontSizeML};
  font-weight: ${props => props.theme.fontWeightBold};
  color: ${props => props.theme.primaryText};
  line-height: ${props => props.theme.lineHeightL};
`

export default H1;
